'use client';

import { useEffect } from 'react';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';

const TRINITY_ID = 2900017491; // not secret

function getPlayerType(paywallCheck: string) {
  return paywallCheck === 'no-paywall' ? '' : 'subscription-locked';
}

function getAdStatus(noTrinityAds: boolean | undefined) {
  return noTrinityAds ? 1 : 0;
}

function buildScriptSrc(url: string, playerType: string, adStatus: number, ownAudio?: string) {
  let src = `https://trinitymedia.ai/player/trinity/${TRINITY_ID}/?pageURL=${encodeURIComponent(
    url,
  )}&FAB=fabAfterClick&subscriber=${adStatus}&playerType=${playerType}`;
  if (ownAudio) {
    src += `&cf=${encodeURIComponent(ownAudio)}`;
  }
  return src;
}

export interface TrinityPlayerProps {
  url: string;
  ownAudio?: string;
  noTrinityAds?: boolean;
}

// NOTE: ownAudio comes from earnings reports

export const TrinityPlayerScript = ({ url, ownAudio, noTrinityAds }: TrinityPlayerProps) => {
  const {
    paywallState: { paywallCheck },
  } = usePaywall();
  useEffect(() => {
    if (window.__TRINITY_SCRIPT_LOADED__) {
      return;
    }

    const trinityRef = document.querySelector('div.impression-element[data-content-placement="trinity_audio_player"]');
    const shouldInitPlayer = paywallCheck !== 'pending' && trinityRef;

    let script: HTMLScriptElement | null = null;

    if (shouldInitPlayer) {
      const playerType = getPlayerType(paywallCheck);
      const adStatus = getAdStatus(noTrinityAds);
      script = document.createElement('script');
      script.src = buildScriptSrc(url, playerType, adStatus, ownAudio);
      script.async = true;
      script.type = 'text/javascript';

      if (window.TRINITY_PLAYER?.api) {
        window.TRINITY_PLAYER.api.deletePlayer();
      }

      if (trinityRef) {
        trinityRef.appendChild(script);
        window.__TRINITY_SCRIPT_LOADED__ = true;
      }
    }
  }, [url, noTrinityAds, paywallCheck, ownAudio]);

  return (
    <div
      className='trinity-tts-pb'
      dir='ltr'
    />
  );
};
